import { render, staticRenderFns } from "./KokubanOutput.vue?vue&type=template&id=20a227f4&scoped=true&"
import script from "./KokubanOutput.vue?vue&type=script&lang=js&"
export * from "./KokubanOutput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a227f4",
  null
  
)

export default component.exports